<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="首页标签"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="标签名称" prop="Name">
              <el-input
                v-model="data.Name"
                placeholder="请填写标签名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="标签图片" prop="IconUrl">
              <single-pic-upload
                v-model="data.IconUrl"
                type="IconUrl"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="标签类型" prop="DataSource">
              <el-select v-model="data.DataSource">
                <el-option label="单页" :value="0"></el-option>
                <el-option label="案例" :value="1"></el-option>
                <el-option label="宝物" :value="2"></el-option>
                <el-option label="课程" :value="3"></el-option>
                <el-option label="客服" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12" v-if="data.DataSource == 0">
            <el-form-item label="对应单页" prop="LabelData" :rules="data.DataSource==0?labelRules.LabelData:null">
              <el-select v-model="data.LabelData" filterable clearable>
                <el-option
                  v-for="item in LabelData"
                  :key="item.RecordId"
                  :label="item.NotesTitle"
                  :value="item.RecordId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12" v-if="data.DataSource == 3">
            <el-form-item label="对应课程" prop="TypePlatformId"  :rules="data.DataSource==3?typeRules.TypePlatformId:null">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="TypePlatforms"
                :value="data.TypePlatformId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <div v-else>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="维护类型" prop="DataType">
                <el-radio-group v-model="data.DataType">
                  <el-radio :label="0">平台维护</el-radio>
                  <el-radio :label="1">店铺维护</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="data.DataType == 0">
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="对应数据类型" prop="LabelData">
                <el-select v-model="data.LabelData" filterable clearable>
                  <el-option label="默认" :value="0">默认</el-option>
                  <el-option label="新品" :value="1">新品</el-option>
                  <el-option label="热销" :value="2">热销</el-option>
                  <el-option label="爆款" :value="3">爆款</el-option>
                  <el-option label="商家列表" :value="4">商家列表</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div> -->
        <!-- <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="显示单价" prop="ShowPrice">
              <el-radio-group v-model="data.ShowPrice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0"> 否 </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import storeSelect from "@/components/shop/store/select";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    storeSelect,
    treeSelect,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        Name: "",
        IconUrl: "",
        DataSource: 0,
        TypePlatformId: null,
        DataType: 0,
        ShowPrice: 1,
        OrderId: 0,
        LabelData: null,
        TypePlatformName: "",
        State:1
      },

      api: require("@/api/mall/label").default,
      typePlatform_api: require("@/api/goods/typeplatform").default,
      type_api: require("@/api/goods/type").default,
      single_api: require("@/api/sy/singlenotes").default,
      isMB: this.$store.state.isMB,
      rules: {
        Name: [{ required: true, message: "标签名称不能为空" }],
        IconUrl: [{ required: true, message: "图片不能为空" }],
        DataSource: [{ required: true, message: "标签类型不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      typeRules: {
        TypePlatformId: [{ required: true, message: "请选择对应课程" }],
      },
      labelRules: {
        LabelData: [{ required: true, message: "请选择对应单页" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      TypePlatforms: [],
      LabelData: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.type_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
    this.single_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.LabelData = res.Data;
      }
    });
  },
  methods: {
    onTreeSelect(t) {
      if (!t) {
        this.data.TypePlatformName = "";
        this.data.TypePlatformId = null;
      } else {
        this.data.TypePlatformName = t.TypepName;
        this.data.TypePlatformId = t.RecordId;
      }
    },
    onCreateOpened(row) {
      this.data.TypeplatformId = null;
      //this.$refs.treeSelect.setData();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.$refs.treeSelect.setData();
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>